import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { MODELS, GUARANTEES } from "../data/content";

export default function ModelsSection() {
  return (
    <section id="models" className="bg-[#0a0a0a] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal className="max-w-3xl mb-16">
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
            You don't buy hours.<br />You buy outcomes.
          </h2>
          <p className="mt-6 text-lg md:text-xl text-neutral-400 leading-relaxed">
            Different businesses win in different ways, so we shape the model around your result, not a rigid price list.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5">
          {MODELS.map((m, i) => (
            <Reveal key={m.title} delay={i * 0.1}>
              <div className={`group relative h-full rounded-3xl p-8 md:p-10 border transition-all duration-500 hover:-translate-y-1 ${m.featured ? "bg-white text-black border-white" : "border-white/15 hover:bg-white/[0.04]"}`} data-testid={`model-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-neutral-500">{m.tag}</span>
                  {m.featured && <span className="rounded-full bg-black/[0.06] text-neutral-600 text-xs px-3 py-1">Most loved</span>}
                </div>
                <h3 className="mt-6 font-display text-3xl tracking-tight font-medium">{m.title}</h3>
                <p className={`mt-2 font-display text-lg ${m.featured ? "text-neutral-500" : "text-neutral-400"}`}>{m.price}</p>
                <p className={`mt-5 leading-relaxed ${m.featured ? "text-neutral-600" : "text-neutral-400"}`}>{m.line}</p>
                <ul className="mt-8 space-y-3">
                  {m.features.map((f) => (
                    <li key={f} className="flex items-start gap-3">
                      <Check size={17} className="mt-1 shrink-0" />
                      <span className={m.featured ? "text-neutral-700" : "text-neutral-300"}>{f}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/book-demo" className={`mt-9 inline-flex items-center gap-2 rounded-full px-7 py-3.5 transition-transform duration-300 hover:-translate-y-0.5 ${m.featured ? "bg-[#0a0a0a] text-white" : "bg-white text-black"}`} data-testid={`model-cta-${i}`}>
                  Find your model <ArrowUpRight size={18} />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <div className="flex flex-wrap gap-x-10 gap-y-3">
            {GUARANTEES.map((g) => (
              <span key={g} className="flex items-center gap-2 text-neutral-400"><Check size={16} /> {g}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
